<template>
  <div :id="`my-toolbar-${props.index}`" class="toolbar">
    <span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>
      <button class="ql-link"></button>
      <button class="ql-clean"></button>
    </span>
    <span class="ql-formats">
      <button
        class="coustomBtn coustomBtn1"
        @click="() => boatBtn1Click(props.index)"
      >
        1
      </button>
      <button
        class="coustomBtn coustomBtn2"
        @click="() => boatBtn2Click(props.index)"
      >
        2
      </button>
      <button
        class="coustomBtn coustomBtn3"
        @click="() => boatBtn3Click(props.index)"
      >
        3
      </button>
      <button
        class="coustomBtn coustomBtn4"
        @click="() => boatBtn4Click(props.index)"
      >
        4
      </button>
      <button
        class="coustomBtn coustomBtn5"
        @click="() => boatBtn5Click(props.index)"
      >
        5
      </button>
      <button
        class="coustomBtn coustomBtn6"
        @click="() => boatBtn6Click(props.index)"
      >
        6
      </button>
    </span>
  </div>
  <div
    :id="`editor-${props.index}`"
    class="quill-editor"
    ref="el => { if (el) editors.value[index] = el; }"
  ></div>
  <div class="d-flex flex-row body_message">
    <p class="error-message text-start">
      <span v-if="props.isBodyInvalid">本文は必須です</span>
    </p>
    <p
      class="text_length"
      v-text="'文字数:' + `${textLength[props.index]}`"
    ></p>
  </div>
</template>

<script setup>
import { onMounted, nextTick, watch, reactive } from "vue";
import Quill from "quill";
import "quill/dist/quill.snow.css";

import { useArticleStore } from "@/store/articleStore";

const articleStore = useArticleStore();

const options = [{}];
const props = defineProps({
  index: Number,
  quills: Object,
  isBodyInvalid: Boolean,
});
/*
class GradeBlot extends Quill.import('blots/inline') {
    static create(value) {
        let node = super.create();
        node.setAttribute('class',value);
        return node;
    }

    static formats(node) {
        return node.getAttribute('class');
    }
}*/
// グローバルオブジェクトに GradeBlot が存在しない場合のみクラスを作成する
if (typeof window.GradeBlot === "undefined") {
  window.GradeBlot = class extends Quill.import("blots/inline") {
    static create(value) {
      let node = super.create();
      node.setAttribute("class", value);
      return node;
    }

    static formats(node) {
      return node.getAttribute("class");
    }
  };
}

window.GradeBlot.blotName = "grade";
window.GradeBlot.tagName = "span";

Quill.register({
  "formats/grade": window.GradeBlot,
});

const textLength = reactive(new Array(10).fill(0));

const setDelta = (index) => {
  const bodyContent = articleStore.articles.article[index].body1;
  //if(bodyContent){console.log(bodyContent)}
  if (bodyContent) {
    try {
      // JSONとして解析を試みる
      const deltaObject = JSON.parse(bodyContent);
      props.quills[index].setContents(deltaObject);
    } catch (error) {
      // JSONとして解析できなかった場合、テキストとして挿入
      props.quills[index].setText(bodyContent);
    }
  }
};

const initializeQuillEditors = (index) => {
  if (!props.quills[index]) {
    Quill.register(
      {
        "formats/grade": window.GradeBlot,
      },
      true
    );
    options[index] = {
      modules: {
        toolbar: {
          container: `#my-toolbar-${index}`,
        },
      },
      theme: "snow",
    };
    const editorContainer = document.getElementById(`editor-${index}`);
    if (editorContainer) {
      const editor = new Quill(editorContainer, options[index]);
      props.quills[index] = editor; // eslint-disable-line vue/no-mutating-props
      editor.on("text-change", function () {
        textLength[index] = editor.getText().replace(/[\n\s]/g, "").length;
      });
      setDelta(index);
    }
  } else {
    setDelta(index);
  }
};

watch(
  () => articleStore.articles.article[props.index].body1,
  () => {
    nextTick(() => {
      initializeQuillEditors(props.index);
    });
  }
);

onMounted(() => {
  nextTick(() => {
    initializeQuillEditors(props.index);
    setDelta(props.index);
  });
});

const boatBtn = (className, text, index) => {
  try {
    const quill = props.quills[index];
    if (!quill) return;

    const length = text.length;

    let cursorPosition = quill.getSelection(true);
    if (!cursorPosition) {
      cursorPosition = { index: quill.getLength(), length: 0 };
    }
    if (quill) {
      if (quill.hasFocus()) {
        let cursorPosition = quill.getSelection(true);
        if (cursorPosition !== null) {
          quill.insertText(cursorPosition.index, text + " ", {
            grade: className,
          });
          quill.removeFormat(cursorPosition.index + length, length + 1);
          quill.setSelection(cursorPosition.index + length + 1);
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
};
const boatBtn1Click = (index) => {
  boatBtn("grade_one", "１", index);
};

const boatBtn2Click = (index) => {
  boatBtn("grade_two", "２", index);
};

const boatBtn3Click = (index) => {
  boatBtn("grade_three", "３", index);
};

const boatBtn4Click = (index) => {
  boatBtn("grade_four", "４", index);
};

const boatBtn5Click = (index) => {
  boatBtn("grade_five", "５", index);
};

const boatBtn6Click = (index) => {
  boatBtn("grade_six", "６", index);
};
</script>

<style scoped>
.coustomBtn {
  max-width: 20px;
  max-height: 20px;
  line-height: 15px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 2px;
}

.coustomBtn1 {
  background: #ebebeb !important;
  border: 1px solid #d5d6d7;
  color: #000;
}

.coustomBtn2 {
  background: #505050 !important;
  border: 1px solid #505050;
  color: #fff;
}

.coustomBtn3 {
  background: #f04141 !important;
  border: 1px solid #f04141;
  color: #fff;
}

.coustomBtn4 {
  background: #4184d0 !important;
  border: 1px solid #4184d0;
  color: #fff;
}

.coustomBtn5 {
  background: #ece962 !important;
  border: 1px solid #d5d6d7;
  color: #000;
}

.coustomBtn6 {
  background: #54b74d !important;
  border: 1px solid #54b74d;
  color: #fff;
}

.toolbar {
  width: 100%;
}

.quill-editor {
  resize: vertical;
  overflow: auto;
  min-width: 100%;
  max-width: 100%;
  height: 60%;
  min-height: 11.4em;
  max-height: 80rem;
}

.text_length {
  text-align: end;
  margin: 0.2rem;
}

.body_message {
  width: 100%;
}

.body_message p {
  width: 50%;
  font-size: 12px;
}

.grade_one {
  color: #000;
  background-color: #ebebeb;
}
.grade_two {
  color: #fff;
  background-color: #505050;
}
.grade_three {
  color: #fff;
  background-color: #f04141;
}
.grade_four {
  color: #fff;
  background-color: #4184d0;
}
.grade_five {
  color: #000;
  background-color: #ece962;
}
.grade_six {
  color: #fff;
  background-color: #54b74d;
}
</style>
